import * as React from 'react'
import { css, SerializedStyles } from '@emotion/react'

type Props = {
  height: string
  width?: string
  color?: string
  additionalStyles?: SerializedStyles
  onClick?: any
}

export const CalendarIconDepartment = ({
  height = '20px',
  width = 'auto',
  color,
  onClick = () => {},
  additionalStyles,
}: Props) => (
  <svg
    viewBox="0 0 18 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    css={[
      css({
        display: 'block',
        height,
        width,
        color,
      }),
      additionalStyles,
    ]}
    onClick={onClick}
  >
      <path d="M9 12C8.71667 12 8.479 11.904 8.287 11.712C8.095 11.52 7.99934 11.2827 8 11C8 10.7167 8.096 10.479 8.288 10.287C8.48 10.095 8.71734 9.99933 9 10C9.28334 10 9.521 10.096 9.713 10.288C9.905 10.48 10.0007 10.7173 10 11C10 11.2833 9.904 11.521 9.712 11.713C9.52 11.905 9.28267 12.0007 9 12ZM5 12C4.71667 12 4.479 11.904 4.287 11.712C4.095 11.52 3.99934 11.2827 4 11C4 10.7167 4.096 10.479 4.288 10.287C4.48 10.095 4.71734 9.99933 5 10C5.28334 10 5.521 10.096 5.713 10.288C5.905 10.48 6.00067 10.7173 6 11C6 11.2833 5.904 11.521 5.712 11.713C5.52 11.905 5.28267 12.0007 5 12ZM13 12C12.7167 12 12.479 11.904 12.287 11.712C12.095 11.52 11.9993 11.2827 12 11C12 10.7167 12.096 10.479 12.288 10.287C12.48 10.095 12.7173 9.99933 13 10C13.2833 10 13.521 10.096 13.713 10.288C13.905 10.48 14.0007 10.7173 14 11C14 11.2833 13.904 11.521 13.712 11.713C13.52 11.905 13.2827 12.0007 13 12ZM9 16C8.71667 16 8.479 15.904 8.287 15.712C8.095 15.52 7.99934 15.2827 8 15C8 14.7167 8.096 14.479 8.288 14.287C8.48 14.095 8.71734 13.9993 9 14C9.28334 14 9.521 14.096 9.713 14.288C9.905 14.48 10.0007 14.7173 10 15C10 15.2833 9.904 15.521 9.712 15.713C9.52 15.905 9.28267 16.0007 9 16ZM5 16C4.71667 16 4.479 15.904 4.287 15.712C4.095 15.52 3.99934 15.2827 4 15C4 14.7167 4.096 14.479 4.288 14.287C4.48 14.095 4.71734 13.9993 5 14C5.28334 14 5.521 14.096 5.713 14.288C5.905 14.48 6.00067 14.7173 6 15C6 15.2833 5.904 15.521 5.712 15.713C5.52 15.905 5.28267 16.0007 5 16ZM13 16C12.7167 16 12.479 15.904 12.287 15.712C12.095 15.52 11.9993 15.2827 12 15C12 14.7167 12.096 14.479 12.288 14.287C12.48 14.095 12.7173 13.9993 13 14C13.2833 14 13.521 14.096 13.713 14.288C13.905 14.48 14.0007 14.7173 14 15C14 15.2833 13.904 15.521 13.712 15.713C13.52 15.905 13.2827 16.0007 13 16ZM2 20C1.45 20 0.979002 19.804 0.587002 19.412C0.195002 19.02 -0.000664969 18.5493 1.69779e-06 18V4C1.69779e-06 3.45 0.196002 2.979 0.588002 2.587C0.980002 2.195 1.45067 1.99933 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.021 2.196 17.413 2.588C17.805 2.98 18.0007 3.45067 18 4V18C18 18.55 17.804 19.021 17.412 19.413C17.02 19.805 16.5493 20.0007 16 20H2ZM2 18H16V8H2V18Z"
       style={{ fill: 'currentcolor' }} />
  </svg>
)
